export const RETRY_ACTION = 'retry';
export const REMOVE_ACTION = 'remove';
